import { z } from 'zod';

export const ExerciseEvaluationSchema = z.object({
    id: z.string().optional(),
    category: z.string().min(1),
    details: z.string().optional(),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateExerciseEvaluationSchema = ExerciseEvaluationSchema.omit({ id: true });
export const UpdateExerciseEvaluationSchema = ExerciseEvaluationSchema.partial();
